// Composables
import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@/composables/auth'
import api from '@/api'
import { useSnackbarStore } from '../store/snackbar'

const routes = [
  {
    path: '/login',
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/views/Login.vue')
      }
    ],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/forgot-password',
    children: [
      {
        path: '',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword.vue')
      }
    ],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    children: [
      {
        path: '/new-password/:username',
        name: 'NewPassword',
        component: () => import('@/views/NewPassword.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    children: [
      {
        path: '/reset/:username',
        name: 'Reset',
        component: () => import('@/views/Reset.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/user-profile',
        name: 'UserProfile',
        component: () => import('@/views/UserProfile.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/Users.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/companies',
        name: 'Companies',
        component: () => import('@/views/Companies.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/document-types',
        name: 'DocumentTypes',
        component: () => import('@/views/DocumentTypes.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence',
        name: 'Diligence',
        component: () => import('@/views/Diligence.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence-kanban',
        name: 'DiligenceKanban',
        component: () => import('@/views/DiligenceKanban.vue')
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:id',
        name: 'Entity',
        component: () => import('@/views/Entity.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:id/sight',
        name: 'DiligenceSight',
        component: () => import('@/views/DiligenceSight.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:id/report',
        name: 'DiligenceReport',
        component: () => import('@/views/DiligenceReport.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:id/custom-report',
        name: 'DiligenceCustomReport',
        component: () => import('@/views/DiligenceCustomReport.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:diligenceId/entity/:entityId',
        name: 'Documents',
        component: () => import('@/views/Documents.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:diligenceId/:documentId',
        name: 'DocumentAnalysis',
        component: () => import('@/views/DocumentAnalysis.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:diligenceId/registration/:registrationId',
        name: 'RegistrationAnalysis',
        component: () => import('@/views/RegistrationAnalysis.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:diligenceId/entity/:entityId/docs',
        name: 'EntityDocs',
        component: () => import('@/views/EntityDocs.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/tracks',
        name: 'Tracks',
        component: () => import('@/views/Tracks.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/tracks/:id',
        name: 'EditTrack',
        component: () => import('@/views/EditTrack.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/review-track',
        name: 'ReviewTrack',
        component: () => import('@/views/ReviewTrack.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/new-track',
        name: 'NewTrack',
        component: () => import('@/views/NewTrack.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/diligence/:diligenceId/law-suits/:entityId',
        name: 'LawSuits',
        component: () => import('@/views/LawSuits.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/financial-statement',
        name: 'FinancialStatement',
        component: () => import('@/views/FinancialStatement.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/default/Default.vue'),
    children: [
      {
        path: '/terms',
        name: 'Terms',
        component: () => import('@/views/Terms.vue'),
        props: true
      }
    ],
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// @ts-ignore
const redirectToLogin = (next) => {
  const snackbarStore = useSnackbarStore()
  snackbarStore.showSnackbar({
    text: 'Tempo de sessão expirado',
    color: 'warning',
    timeout: 4000
  })

  localStorage.clear()
  return next('/login')
}

router.beforeEach(async (to, from, next) => {
  const auth = useAuth()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const isAuthenticated = !(await auth.isJwtExpired())

  if (to.path === '/login' && isAuthenticated) return next('/')

  if (requiresAuth) {
    if (isAuthenticated) {
      // @ts-ignore
      if (auth.hasPermission(to.name)) return next()
      return next('/')
    } else {
      return redirectToLogin(next)
    }
  }

  return next()
})

export default router
